import axios from 'axios';
import { generateRequestUrl } from '../game-mode';
import { store } from '../../store';
import { loginSuccess, logout } from '../../store/adminSlices/auth';
import { getCurrentLangId } from '../utils';
import { API_ERRORS } from '../../app.config.vars/errorCodes';
const api = axios.create({
    baseURL: '/_api',
});
let isRefreshing = false;
let failedQueue = [];
const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
        if (token) {
            prom.resolve(token);
        }
        else {
            prom.reject(error);
        }
    });
    failedQueue = [];
};
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.set('Authorization', `Bearer ${token}`);
    }
    config.headers.set('X-Locale', getCurrentLangId());
    return config;
}, (error) => Promise.reject(error));
api.interceptors.response.use((response) => response, async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 &&
        error.response?.data?.error.code === API_ERRORS.tokenExpired &&
        !originalRequest._retry) {
        if (isRefreshing) {
            return new Promise((resolve, reject) => {
                failedQueue.push({
                    resolve: (token) => {
                        originalRequest.headers = {
                            ...originalRequest.headers,
                            Authorization: `Bearer ${token}`,
                        };
                        resolve(api(originalRequest));
                    },
                    reject: (err) => reject(err),
                });
            });
        }
        originalRequest._retry = true;
        isRefreshing = true;
        try {
            const refreshToken = localStorage.getItem('refreshToken');
            const res = await axios.post(generateRequestUrl('/token/refresh'), {
                token: refreshToken,
            });
            const newToken = res.data.jwt;
            const newRefreshToken = res.data.refreshToken || refreshToken;
            localStorage.setItem('token', newToken);
            localStorage.setItem('refreshToken', newRefreshToken);
            store.dispatch(loginSuccess({ token: newToken, refreshToken: newRefreshToken }));
            processQueue(null, newToken);
            originalRequest.headers = {
                ...originalRequest.headers,
                Authorization: `Bearer ${newToken}`,
            };
            return api(originalRequest);
        }
        catch (refreshError) {
            processQueue(refreshError, null);
            store.dispatch(logout());
            return Promise.reject(refreshError);
        }
        finally {
            isRefreshing = false;
        }
    }
    return Promise.reject(error);
});
export default api;
